export const workQueueOverdueSectionSelectors = {
  snoozeAllButton: 'snooze-all-overdue-reports-button',
  snoozeAllPopup: 'snooze-all-overdue-reports-popup'
};
